export const ALIST_FILE_URL = 'staticFiles/alistFiles';
